// extracted by mini-css-extract-plugin
export var attachment = "_mc-a";
export var emailContainer = "_mc-4";
export var emailContentPaddedContainer = "_mc-b";
export var emailHeader = "_mc-6";
export var emailIframe = "_mc-3";
export var emailInfoIcon = "_mc-9";
export var emailShortenedSummary = "_mc-e";
export var infoDropdown = "_mc-0";
export var infoRowBoundedContent = "_mc-d";
export var internal = "_mc-5";
export var merchant = "_mc-8";
export var messageInputContainer = "_mc-h";
export var normal = "_mc-7";
export var replyCard = "_mc-f";
export var subtleButton = "_mc-1";
export var subtleButtonIconContainer = "_mc-2";
export var toggleViewRepliesButton = "_mc-c";
export var wrappingText = "_mc-g";